<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="TOC"><a href="#/Foreword">Foreword, by Joni Mayhan</a></p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC"><span href="#/Timeline" title="Link target outside of Sample">Timeline</span></p>
<p class="TOC1"><span href="#/Chapter01" title="Link target outside of Sample"><b>The History</b></span></p>
<p class="TOC2"><span href="#/Chapter01#h_1" title="Link target outside of Sample">Battles of Lexington and Concord</span></p>
<p class="TOC2"><span href="#/Chapter01#h_2" title="Link target outside of Sample">Concord’s Colonial Inn</span></p>
<p class="TOC2"><span href="#/Chapter01#h_3" title="Link target outside of Sample">Paul Revere’s Ride</span></p>
<p class="TOC1"><span href="#/Chapter02" title="Link target outside of Sample"><b>The Players</b></span></p>
<p class="TOC2"><span href="#/Chapter02#h_4" title="Link target outside of Sample">Ammi White</span></p>
<p class="TOC2"><span href="#/Chapter02#h_5" title="Link target outside of Sample">Dr. Timothy Minot</span></p>
<p class="TOC2"><span href="#/Chapter02#h_6" title="Link target outside of Sample">Henry David Thoreau</span></p>
<p class="TOC1"><span href="#/Chapter03" title="Link target outside of Sample"><b>The Hauntings</b></span></p>
<p class="TOC2"><span href="#/Chapter03#h_7" title="Link target outside of Sample">Ghostly Guests</span></p>
<p class="TOC2"><span href="#/Chapter03#h_8" title="Link target outside of Sample">Haunted Rooms</span></p>
<p class="TOC2"><span href="#/Chapter03#h_9" title="Link target outside of Sample">TV Investigations</span></p>
<p class="TOC1"><span href="#/Chapter04" title="Link target outside of Sample"><b>The Legends</b></span></p>
<p class="TOC2"><span href="#/Chapter04#h_10" title="Link target outside of Sample">Louisa May Alcott</span></p>
<p class="TOC2"><span href="#/Chapter04#h_11" title="Link target outside of Sample">Nathaniel Hawthorne</span></p>
<p class="TOC2"><span href="#/Chapter04#h_12" title="Link target outside of Sample">Ralph Waldo Emerson</span></p>
<p class="TOC1"><span href="#/Chapter05" title="Link target outside of Sample"><b>The Neighbors</b></span></p>
<p class="TOC2"><span href="#/Chapter05#h_13" title="Link target outside of Sample">Monument Square</span></p>
<p class="TOC2"><span href="#/Chapter05#h_14" title="Link target outside of Sample">Sleepy Hollow Cemetery</span></p>
<p class="TOC2"><span href="#/Chapter05#h_15" title="Link target outside of Sample">The Old Manse</span></p>
<p class="TOC1"><span href="#/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="TOC"><span href="#/Sources" title="Link target outside of Sample">Sources</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?939d50f2